// import { Visibility } from "@mui/icons-material";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import {
//   Button,
//   MenuItem,
//   Paper,
//   Popover,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   TextField,
// } from "@mui/material";
// import { styled } from "@mui/system";

import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../../utils/routes";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import PageStyle from "../../../Components/Layout/PageLayout";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import {
  CalendarFilter2,
  FilterButton,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import editIcon from "./Edit-pen.svg";
import bin from "./bin.svg";
import { toast } from "react-toastify";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useDispatch, useSelector } from "react-redux";
import {
  ApproveAuxiliaryServiceRequest,
  CancelEmployeeMedicalRequisition,
  DeclineAuxiliaryServiceRequest,
} from "../../../../../utils/redux/HR/HRSlice";
import Pagination from "../../../Components/Pagination/Pagination";
import { TableActions } from "../../../Components/Misc/Actions";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import Table from "../../../Components/Table/Table";
import {
  useApproveBookingsMutation,
  useDeclineBookingsMutation,
  useGetBookingFacilityQuery,
  useGetBookingsQuery,
} from "../../../../api/financeApi";
import {
  FormatStatus,
  getColorByStatus,
} from "../../../../../utils/functions/FormatStatus";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   backgroundColor: "#F9FAFB",
//   fontSize: "14px",
//   fontWeight: "500",
//   color: "#333",
//   borderBottom: "none",
// }));

// const statusColors = {
//   Active: "bg-green-100 text-green-700",
//   Inactive: "bg-red-100 text-red-700",
//   Maintenance: "bg-yellow-100 text-yellow-700",
// };

// const ManageBookingRequest = () => {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState();
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [bookingServiceId, setBookingServiceId] = useState();
//   const [rowData, setRowData] = useState();
//   const addFacilitiesUrl = URL.AddFacilities.replace(":id", bookingServiceId);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const { data, isLoading } = useGetBookingsQuery({
//     PageSize: rowsPerPage,
//     PageNumber: page,
//   });
//   const handleClose = () => {
//     setAnchorEl(null);
//   };
//   const [onDelete, { isLoading: deleteLoading }] =
//     useDeleteBookServiceMutation();
//   const handleDelete = async () => {
//     try {
//       const res = await onDelete({ id: bookingServiceId }).unwrap();
//       if (res?.successful === true) {
//         toast.success(res?.statusMessage);
//         handleClose();
//       } else {
//         toast.error(res?.statusMessage);
//       }
//     } catch (err) {
//       toast.error(err?.data?.statusMessage);
//     }
//   };
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const open = Boolean(anchorEl);
//   const id = open ? "simple-popover" : undefined;

//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   const handleStatusChange = (event) => {
//     setSelectedStatus(event.target.value);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const filteredData = data?.result?.filter((row) => {
//     const matchesSearchTerm = row?.requisitorName
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase());

//     return matchesSearchTerm;
//   });

//   return (
//     <RouteLayout title="Service Setup">
//       <div className="p-[20px]">
//         <div className="mb-[30px]">
//           <h1 className="text-[#4B664C] font-[500] text-[30px]">
//             Service Setup
//           </h1>
//         </div>
//         <div className="p-6 bg-white shadow-md rounded-lg overflow-scroll">
//           <div className="flex justify-between items-center mb-4">
//             <div className="flex justify-between items-center gap-3">
//               <div className="flex flex-col">
//                 <span>Search</span>
//                 <TextField
//                   label="Search"
//                   variant="outlined"
//                   value={searchTerm}
//                   onChange={handleSearchChange}
//                   size="small"
//                 />
//               </div>
//               <CalendarFilter2
//                 name="Select Date Range"
//                 setStartDate={setStartDate}
//                 setEndDate={setEndDate}
//               />
//               <div className="flex flex-col">
//                 <span>Status</span>
//                 <TextField
//                   select
//                   label="Status"
//                   value={selectedStatus}
//                   onChange={handleStatusChange}
//                   variant="outlined"
//                   size="small"
//                   sx={{
//                     width: 216,
//                   }}
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   <MenuItem value={0}>Active</MenuItem>
//                   <MenuItem value={1}>Inactive</MenuItem>
//                   <MenuItem value={2}>Maintenance</MenuItem>
//                 </TextField>
//               </div>
//             </div>
//           </div>
//           <div>{isLoading && <p>Loading...</p>}</div>
//           <TableContainer component={Paper}>
//             <Table className="min-w-full">
//               <TableHead className="min-w-full">
//                 <TableRow>
//                   <StyledTableCell>S/N</StyledTableCell>
//                   <StyledTableCell>Requested By</StyledTableCell>
//                   <StyledTableCell>Email</StyledTableCell>
//                   <StyledTableCell>Phone Number</StyledTableCell>
//                   <StyledTableCell>Total Unavailable</StyledTableCell>
//                   <StyledTableCell>Facility Name</StyledTableCell>
//                   <StyledTableCell>Start Date</StyledTableCell>
//                   <StyledTableCell>End Date</StyledTableCell>
//                   <StyledTableCell>Date Requested</StyledTableCell>
//                   <StyledTableCell>Status</StyledTableCell>
//                   <StyledTableCell>Actions</StyledTableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody className="min-w-full">
//                 {filteredData?.map((row, index) => (
//                   <TableRow key={row?.id}>
//                     <StyledTableCell>{index + 1}</StyledTableCell>
//                     <StyledTableCell>{row?.requisitorName}</StyledTableCell>
//                     <StyledTableCell>{row?.email}</StyledTableCell>
//                     <StyledTableCell>{row?.phoneNumber}</StyledTableCell>
//                     <StyledTableCell>{row?.totalUnavailable}</StyledTableCell>
//                     <StyledTableCell>{row?.facilityName}</StyledTableCell>
//                     <StyledTableCell>
//                       {FormatDateTime(row?.startDate)}
//                     </StyledTableCell>
//                     <StyledTableCell>
//                       {FormatDateTime(row?.endDate)}
//                     </StyledTableCell>
//                     <StyledTableCell>{row?.dateRequested}</StyledTableCell>
//                     <StyledTableCell>
//                       <span
//                         className={`rounded-full px-2 py-1 ${
//                           statusColors[row?.status]
//                         }`}
//                       >
//                         {row?.status}
//                       </span>
//                     </StyledTableCell>
//                     <StyledTableCell>
//                       <div className="flex items-center">
//                         <button
//                           onClick={() =>
//                             navigate(
//                               "/dashboard/finance/" + URL.ServiceDetailsView
//                             )
//                           }
//                           className="bg-[#6E9170] rounded-l-md p-1"
//                         >
//                           <Visibility className="text-[#fff]" />
//                         </button>

//                         <div
//                           onClick={() => {
//                             setBookingServiceId(row?.id);
//                             setRowData(row);
//                           }}
//                         >
//                           <button
//                             onClick={handleClick}
//                             className="bg-[#4B664C] p-1 rounded-r-md"
//                           >
//                             <KeyboardArrowDownIcon className="text-[#fff]" />
//                           </button>
//                         </div>
//                       </div>
//                     </StyledTableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <Popover
//             id={id}
//             open={open}
//             anchorEl={anchorEl}
//             onClose={handleClose}
//             anchorOrigin={{
//               vertical: "bottom",
//               horizontal: "center",
//             }}
//             transformOrigin={{
//               vertical: "top",
//               horizontal: "center",
//             }}
//           >
//             <div className="p-3 flex flex-col gap-8 h-[140px] w-[160px]">
//               <div className="flex gap-3 items-center">
//                 <img
//                   className="w-[14px] h-[14px]"
//                   src={editIcon}
//                   alt="edit con"
//                 />
//                 <Link
//                   to={`/dashboard/finance/${URL.UpdateService.replace(
//                     ":data",
//                     JSON.stringify(rowData)
//                   )}`}
//                   className="text-[#4B664C] hover:text-[#305F32]"
//                 >
//                   Update
//                 </Link>
//               </div>
//               <div className="flex gap-3 items-center">
//                 <Visibility className="w-[14px] h-[14px]" />
//                 <Link
//                   to={`/dashboard/finance/${URL.ManageBookingRequest}`}
//                   className="text-[#4B664C] hover:text-[#305F32]"
//                 >
//                   View
//                 </Link>
//               </div>
//               <div onClick={handleDelete} className="flex gap-3 items-center">
//                 <img
//                   className="w-[14px] h-[14px]"
//                   src={bin}
//                   alt="delete icon"
//                 />
//                 <button disabled={deleteLoading}>
//                   {deleteLoading ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </Popover>
//           <TablePagination
//             component="div"
//             count={filteredData?.length}
//             page={page}
//             onPageChange={handleChangePage}
//             rowsPerPage={rowsPerPage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             rowsPerPageOptions={[5, 10, 25]}
//             className="mt-4"
//           />
//         </div>
//       </div>
//     </RouteLayout>
//   );
// };

// export default ManageBookingRequest;

function ManageBookingRequest() {
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [find, setFind] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [action, setAction] = useState();
  const [filter, setFilter] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    data,
    isLoading: Loading,
    refetch,
  } = useGetBookingsQuery({
    PageSize: rowsPerPage,
    PageNumber: page,
    Status: filter,
    search: searchTerm,
  });

  const [approveBookings, { isLoading: isApproving }] =
    useApproveBookingsMutation();
  const [declineBookings, { isLoading: isDeclining }] =
    useDeclineBookingsMutation();
  const { data: facilityData, isLoading: facilityLoading } =
    useGetBookingFacilityQuery({
      PageSize: rowsPerPage,
      PageNumber: page,
    });
  console.log({ facilityData, facilityLoading });

  // write a func that accepts an id and returns the data, map through facilityData and return the data
  const getFacilityData = (id) => {
    const data = facilityData?.result?.items?.find((x) => x.id === id);
    return data?.facilityName;
  };

  const all_auxiliary_service_request_data = data?.result?.items;
  const all_auxiliary_service_request_data_pagination = data?.result;
  console.log("data", data?.result?.items);

  const [refresh, setRefresh] = useState(false);

  const apiData = {
    pageSize: pageSize,
    pageNumber: pageNumber,
    search: search,
    ApprovalStatus: filter,
  };

  useEffect(() => {
    if (approvalStatus !== null) {
      apiData["Status"] = approvalStatus;
    }
    if (search !== null && search !== "" && search !== " ") {
      apiData["Search"] = search;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // approvalStatus,
    pageNumber,
    pageSize,
    // search,
    action,
    find,
    refresh,
  ]);

  const filterBy = [
    // {
    //   name: "All",
    //   filter: 411,
    // },
    {
      name: "Initiated",
      filter: 1,
    },
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Declined",
      filter: 7,
    },
  ];

  const [modalAction, setModalAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [comment, setComment] = useState("");

  const handleOpenModal = (action, employeeId) => {
    setModalAction(action);
    setSelectedEmployeeId(employeeId);
    setShowModal(true);
  };

  const handleModalActionButtonClick = async () => {
    if (comment === "") {
      toast.error("Comment is required");
      return;
    }

    // Ensure selectedEmployeeId and modalAction are valid
    if (selectedEmployeeId && modalAction) {
      const payload = {
        id: selectedEmployeeId,
        comment,
      };

      let actionDispatchFunction;

      switch (modalAction) {
        case "Approve":
          actionDispatchFunction = approveBookings;
          break;
        case "Decline":
          actionDispatchFunction = declineBookings;
          break;
        case "Cancel":
          actionDispatchFunction = CancelEmployeeMedicalRequisition;
          break;
        default:
          toast.error("Invalid action type");
          return;
      }

      if (actionDispatchFunction) {
        try {
          // Unwrap to get the fulfilled value directly
          const res = await actionDispatchFunction(payload).unwrap();

          console.log("res", res); // Directly logging the response object

          if (res?.successful) {
            refetch();
            setShowModal(false);
            toast.success(`${modalAction}d successfully`);
          } else {
            toast.error(res?.statusMessage || "Action failed");
          }
        } catch (error) {
          console.error("Error:", error);
          toast.error(
            error?.message || "An error occurred while performing the action"
          );
        }
      } else {
        toast.error("Invalid action function");
      }
    } else {
      toast.error(
        "Please ensure an employee is selected and a valid action is chosen."
      );
    }
  };

  const handleCloseModal = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleCloseModal);
    return () => {
      document.removeEventListener("mousedown", handleCloseModal);
    };
  }, []);

  return (
    <div
      style={{
        padding: "20px",
      }}
    >
      <PageStyle
        title={"Manage Booking Requests"}
        hasBack={false}
        // action={actionButton}
        isMain={true}
      >
        <div className={DashboardStyle.dashboard_filter}>
          <SearchFilter
            text={(value) => setSearchTerm(value)}
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <ProDropFilter
            filter={filter}
            setFilter={setFilter}
            name={"Status"}
            filterBy={filterBy}
          />
          {/* <FilterButton onClick={() => setFind(!find)} name="" /> */}
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                <th>Requested By</th>
                <th>Facility Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Date Requested</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {all_auxiliary_service_request_data?.map((acq, index) => (
                <AcqTable
                  {...acq}
                  data={all_auxiliary_service_request_data}
                  index={index}
                  isLoading={Loading}
                  handleOpenModal={handleOpenModal}
                  getFacilityData={getFacilityData}
                />
              ))}
            </tbody>
          </Table>
        </div>

        {/* <Pagination
          last_page={all_auxiliary_service_request_data_pagination?.totalPages}
          present_page={all_auxiliary_service_request_data_pagination?.page}
          totalRows={all_auxiliary_service_request_data_pagination?.total}
          pageSize={rowsPerPage} // controlled by the `rowsPerPage` state
          setPageSize={(pageSize) => setRowsPerPage(pageSize)} // set rows per page
          click={(page) => setPage(page)} // set page number when a page is clicked
        /> */}

        {showModal && (
          <div className={DashboardStyle.modalOverlay}>
            <div className={DashboardStyle.modal1} ref={modalRef}>
              <div className={DashboardStyle.modalcontent1}>
                <div className={DashboardStyle.cycler}>
                  <AiOutlineExclamationCircle
                    size={24}
                    style={{ color: "brown" }}
                  />
                </div>
                <h1 style={{ textAlign: "center", fontSize: "20px" }}>
                  {modalAction === "Approve"
                    ? "Approve Request"
                    : modalAction === "Decline"
                    ? "Decline Request"
                    : modalAction === "Cancel"
                    ? "Cancel Request"
                    : ""}
                </h1>

                <div className={DashboardStyle.textyarea}>
                  <label>
                    Comment <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    rows={6}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    style={{
                      border: "1px solid #D5D5D5",
                      borderRadius: "5px",
                      width: "100%",
                      padding: "10px",
                    }}
                  >
                    Enter Comment
                  </textarea>
                </div>
              </div>

              <div className={DashboardStyle.modalfooter1}>
                <button
                  className={DashboardStyle.greenButton}
                  onClick={handleModalActionButtonClick}
                >{`Yes, ${modalAction}`}</button>
                <button
                  onClick={() => setShowModal(false)}
                  className={DashboardStyle.whiteButton2}
                >
                  No, Close
                </button>
              </div>
            </div>
          </div>
        )}
      </PageStyle>
    </div>
  );
}

export default ManageBookingRequest;

function AcqTable({
  uuId,
  id,
  approvalStatus,
  updatedDate,
  index,
  handleOpenModal,
  amount,
  auxiliaryServiceTypeId,
  createdBy,
  createdDate,
  assetName,
  facilityId,
  startDate,
  endDate,
  getFacilityData,
}) {
  return (
    <>
      <tr key={index}>
        <td>{createdBy}</td>
        <td>{getFacilityData(facilityId)}</td>
        <td>{FormatDateTime(startDate)}</td>
        <td>{FormatDateTime(endDate)}</td>
        <td>{FormatDateTime(createdDate)}</td>
        <td>
          <span
            style={{
              color: getColorByStatus(approvalStatus).color,
              backgroundColor: getColorByStatus(approvalStatus).backgroundColor,
              padding: "4px", // Optional padding for better visual presentation
              borderRadius: "4px", // Optional rounded corners
            }}
          >
            {FormatStatus(approvalStatus)}
          </span>
        </td>
        <td>
          <TableActions
            hasChildren={true}
            url={`/dashboard/finance/${URL.ManageBookingRequestView}/${id}`}
          >
            {[
              // {
              //   name: "Edit Employee Medical Requisition",
              //   action: handleEditPayroll,
              // },
              {
                name: "Approve Request",
                action: () => handleOpenModal("Approve", id),
              },
              {
                name: "Decline Request",
                action: () => handleOpenModal("Decline", id),
              },
              // {
              //   name: "Cancel Employee Medical Requisition",
              //   action: () => handleOpenModal("Cancel", id),
              // },
            ]}
          </TableActions>
        </td>
      </tr>
    </>
  );
}
